export function fmtTime(sec = 0) {
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  return `${m}m ${s.toString().padStart(2, "0")}s`;
}

export function hashCode(str = "") {
  let h = 0;
  for (let i = 0; i < str.length; i++) h = (h * 31 + str.charCodeAt(i)) >>> 0;
  return h;
}

export function clamp(n, min, max) {
  return Math.max(min, Math.min(max, n));
}

// export const TIME_LIMIT_BY_GAME_ID = { 1: 60 * 60, 2: 60 * 60, 3: 60 * 60 };
// export const BEST_REALISTIC_SEC_BY_GAME_ID = { 1: 45 * 60, 2: 22 * 60, 3: 22 * 60 };
// TESTS BETA
export const TIME_LIMIT_BY_GAME_ID = { 1: 90 * 60, 2: 90 * 60, 3: 90 * 60 };
export const BEST_REALISTIC_SEC_BY_GAME_ID = { 1: 70 * 60, 2: 22 * 60, 3: 22 * 60 };

export function getTimeLimitSec(gameId) {
  return TIME_LIMIT_BY_GAME_ID[Number(gameId)] ?? 60 * 60;
}

export function getBestRealisticSec(gameId, timeLimitSec) {
  return BEST_REALISTIC_SEC_BY_GAME_ID[Number(gameId)] ?? Math.round((timeLimitSec || 3600) * 0.35);
}

export function getPointsBreakdownFromDB(data, stats) {
  let b = data?.pointsBreakdown;
  if (typeof b === "string") { try { b = JSON.parse(b); } catch { b = null; } }

  if (b && typeof b === "object") {
    const base = Number(b.base ?? 0) || 0;
    const finishBonus = Number(b.finishBonus ?? 0) || 0;
    const timeBonus = Number(b.timeBonus ?? 0) || 0;
    const interactionsBonus = Number(b.interactionsBonus ?? 0) || 0;
    const errorsPenalty = Number(b.errorsPenalty ?? 0) || 0;
    const hintsPenalty = Number(b.hintsPenalty ?? 0) || 0;
    const answersPenalty = Number(b.answersPenalty ?? 0) || 0;
    const raw = Number(b.raw ?? (base + timeBonus + interactionsBonus - errorsPenalty - hintsPenalty - answersPenalty)) || 0;
    const points = Number(b.points ?? data?.points ?? raw) || 0;
    const totalPenalties = errorsPenalty + hintsPenalty + answersPenalty;
    const bonusEmpathie = Number(b.bonus_empathie ?? 0) || 0;

    return {
      timeScore: timeBonus,
      penaltyErrors: errorsPenalty,
      penaltyHints: hintsPenalty,
      penaltyAnswers: answersPenalty,
      bonusTime: timeBonus,
      bonusInteractions: interactionsBonus,
      bonusTaquin: Number(b.taquinBonus ?? 0) || 0,
      bonusPuzzle: Number(b.puzzleBonus ?? 0) || 0,
      bonusEmpathie,
      totalPenalties,
      raw, points, base, finishBonus,
      timeRemainingSec: Number(b.timeRemainingSec ?? 0) || 0,
      timeLimitSec: Number(b.timeLimitSec ?? 0) || 0,
      playedDurationSec: Number(b.playedDurationSec ?? 0) || 0,
      interactions: Number(b.interactions ?? 0) || 0,
      errors: Number(b.errors ?? 0) || 0,
      hints: b.hints || { l1: 0, l2: 0, l3: 0 },
      answers: Number(b.answers ?? 0) || 0,
    };
  }

  // fallback
  const playedDuration = data?.playedDuration || 0;
  const timeScore = Math.max(0, 6000 - Math.floor(playedDuration * 6));
  const l1 = stats?.totals?.hints?.l1 || 0;
  const l2 = stats?.totals?.hints?.l2 || 0;
  const l3 = stats?.totals?.hints?.l3 || 0;
  const ans = stats?.totals?.hints?.answer || 0;
  const penaltyHints = l1 * 40 + l2 * 90 + l3 * 160;
  const penaltyAnswers = ans * 220;
  const errors = stats?.totals?.wrongPwdTotal || 0;
  const penaltyErrors = errors * 120;

  return {
    timeScore, penaltyErrors, penaltyHints, penaltyAnswers,
    bonusTime: 0, bonusInteractions: 0, bonusTaquin: 0, bonusPuzzle: 0, bonusEmpathie: 0,
    totalPenalties: penaltyErrors + penaltyHints + penaltyAnswers,
    raw: Math.max(0, timeScore - (penaltyErrors + penaltyHints + penaltyAnswers)),
    points: Number(data?.points ?? 0) || 0,
    base: 0, finishBonus: 0,
    timeRemainingSec: 0, timeLimitSec: 0, playedDurationSec: playedDuration,
    interactions: 0, errors, hints: { l1, l2, l3 }, answers: ans,
  };
}